import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function AdminSidebar({ groups, tab, setTab }) {
    const [open, setOpen] = useState(false);
    const all = groups.flatMap((g) => g.items);
    const current = all.find((t) => t.id === tab) || all[0];

    return (
        <aside className="lg:w-60 shrink-0 lg:sticky lg:top-24 self-start w-full" data-testid="admin-sidebar">
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="lg:hidden adm-panel w-full flex items-center justify-between px-4 py-3 mb-3 font-display font-bold uppercase text-sm tracking-wider"
                data-testid="admin-sidebar-toggle"
            >
                <span className="flex items-center gap-2">
                    <current.icon className="w-4 h-4 text-[hsl(var(--primary))]" /> {current.label}
                </span>
                {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
            </button>
            <nav className={`${open ? "block" : "hidden"} lg:block adm-panel p-3 space-y-4`}>
                {groups.map((g) => (
                    <div key={g.title}>
                        <div className="label-kicker px-3 mb-1.5 text-[10px]">{g.title}</div>
                        <div className="space-y-0.5 pl-3">
                            {g.items.map((t) => (
                                <button
                                    key={t.id}
                                    type="button"
                                    onClick={() => { setTab(t.id); setOpen(false); }}
                                    className={`adm-nav-item ${tab === t.id ? "is-active" : ""}`}
                                    data-testid={`admin-tab-${t.id}`}
                                >
                                    <t.icon className="w-4 h-4 shrink-0" />
                                    <span className="flex-1 text-left">{t.label}</span>
                                    {t.badge ? (
                                        <span className="text-[10px] font-mono px-1.5 py-0.5 rounded bg-[hsl(var(--primary)/0.2)] text-[hsl(var(--primary))]">
                                            {t.badge}
                                        </span>
                                    ) : null}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </nav>
        </aside>
    );
}
